export default __webpack_public_path__ + "static/media/heinz.50cada48.jpg";